export default __webpack_public_path__ + "static/media/shibar.45ebee66.svg";